<template>
  <component
    v-bind="$attrs"
    :class="style"
    :href="href"
    :as="as"
    :is="is"
  >
    <Icon
      v-if="icon"
      :type="icon"
      class="m-auto"
      size="5"
    />
    <slot name="default">
      <span>{{ text }}</span>
    </slot>
  </component>
</template>

<script>
import Icon from 'Web/Shared/Icon.vue';
import { Link } from '@inertiajs/inertia-vue3';
import { computed } from 'vue';

export default {
  inheritAttrs: false,
  components: {
    Icon,
    Link,
  },
  props: {
    as: String,
    display: {
      type: String,
      default: 'link'
    },
    href: String,
    icon: String,
    inertia: {
      type: Boolean,
      default: null
    },
    text: String,
  },
  setup(props) {
    const style = computed(() => ({
      'button': 'button',
      'ghost': 'button button--ghost',
      'link': 'link',
    }[props.display]));

    const is = computed(() => props.inertia !== false && props.href
      ? 'link'
      : props.as ?? (props.href ? 'a' : 'button')
    );

    return {
      style,
      is,
    }
  }
}
</script>
